import { useEffect } from "react";

/**
 * Lightweight SEO helper — sets document.title, meta description,
 * OpenGraph title/description, and a noindex directive when requested.
 * No react-helmet dependency needed.
 */
export default function SEO({ title, description, noindex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}='${name}']`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("description", description);
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", "website", "property");
    setMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
    return () => {
      // Reset noindex when leaving noindex page so other routes stay indexable
      if (noindex) setMeta("robots", "index, follow");
    };
  }, [title, description, noindex]);
  return null;
}
